export const snackbarConstants = {
  SHOW_SUCCESS_MESSAGE: "SHOW_SUCCESS_MESSAGE",
  SHOW_ERROR_MESSAGE: "SHOW_ERROR_MESSAGE",
  CLEAR_SNACKBAR: "CLEAR_SNACKBAR"
};

export default snackbarConstants;
